<template>
  <a-dialog ref="dialog" name="choose_day_report" size="small" :loading="loading" @open="opened" @close="$reset">
    <span slot="title">{{ $t('title') }}</span>
    <div slot="content">
      <div class="mb-4">{{ $t('content') }}
      </div>
      <div>
        <v-btn text color="primary" @click="select(date)">
          <v-icon left>
            mdi-calendar-clock
          </v-icon>
          {{ $moment(date).format('L') }}
        </v-btn>
      </div>
      <div v-for="report in reports" :key="report">
        <v-btn text color="success" @click="select(report)">
          <v-icon left>
            mdi-account-clock
          </v-icon>
          {{ $moment(report).format('L') }} à {{ $moment(report).format('LT') }}
        </v-btn>
      </div>
    </div>
  </a-dialog>
</template>

<script>
import moment from 'moment'

export default {
  name: 'ChooseDayReportDialog',
  data () {
    return {
      loading: '',
      date: null,
      callback: null,
      carrier: {}
    }
  },
  computed: {
    reports () {
      return this.$services.monitoring.computedReportList.filter(report => {
        return this.$moment(report).isSame(this.date, 'day')
      })
    }
  },
  methods: {
    opened ({ date, callback }) {
      this.date = this.$moment(date).format('YYYY-MM-DD HH:mm')
      this.callback = callback
    },
    async select (date) {
      this.loading = this.$t('loading')
      try {
        const path = this.$models.CarrierObjects.monitorReport(date)
        const response = await this.$carrier.get(path)
        const reportListObject = response.data
        const sample = Object.keys(reportListObject.samples).find(key => reportListObject.samples[key] === date)
        this.callback(moment(date).format(sample === 0 ? 'YYYY-MM-DD 00:00' : 'YYYY-MM-DD HH:mm'))
        if (this.$refs.dialog) this.$refs.dialog.close()
      } catch (e) {
        this.$ui.error(this.$t('error') + e)
        this.loading = ''
      }
    }
  }
}
</script>

<i18n>
{
	"en": {
		"content": "You have several position reports for this day, select the time at which you want to view the positions.",
		"error": "Unable to open position report:",
		"loading": "Loading positions",
		"title": "Choose a time"
	},
	"es": {
		"content": "Tiene varios informes de posición para este día, seleccione la hora a la que desea ver las posiciones.",
		"error": "No se pudo abrir el informe de posición:",
		"loading": "Carga de las posiciones",
		"title": "Eligir una hora"
	},
	"fr": {
		"content": "Vous avez plusieurs rapports de positions pour cette journée, selectionnez l'heure à laquelle vous souhaitez consulter les positions.",
		"error": "Impossible d'ouvrir le rapport de positions : ",
		"loading": "Chargement des positions",
		"title": "Choisir une heure"
	},
	"it": {
		"content": "Hai diversi rapporti di posizione per questo giorno, seleziona l'ora in cui desideri visualizzare le posizioni.",
		"error": "Impossibile aprire il rapporto di posizioni:",
		"loading": "Caricamento delle posizioni",
		"title": "Scegli un orario"
	},
	"pt": {
		"content": "Tem vários relatórios de posição para este dia, selecione a hora em que deseja ver as posições.",
		"error": "Impossível abrir o relatório de posições:",
		"loading": "A carregar as posições",
		"title": "Escolher uma hora"
	},
	"pl": {
		"content": "Masz kilka raportów pozycji na ten dzień, wybierz godzinę, o której chcesz zobaczyć pozycje.",
		"error": "Nie można otworzyć raportu pozycji:",
		"loading": "Ładowanie pozycji",
		"title": "Wybierz godzinę"
	}
}
</i18n>
